import React, { useEffect, useRef, useState } from 'react';

interface PropsSpinner {
  tamanho?: number;
  corPrincipal: string;
}

export default function Spinner({ tamanho = 100, corPrincipal }: PropsSpinner) {
  const barrasRef = useRef<(SVGRectElement | null)[]>([]);
  const [quadro, setQuadro] = useState(0);
  const cores = gerarCoresGradativas(corPrincipal, 6);

  function gerarCoresGradativas(corBase: string, passos: number): string[] {
    const [r, g, b] = hexParaRgb(corBase);
    const coresGradativas = [];
    for (let i = 0; i < passos; i++) {
      const fator = (i + 1) / passos;
      const novoR = Math.min(255, Math.floor(r + (255 - r) * fator));
      const novoG = Math.min(255, Math.floor(g + (255 - g) * fator));
      const novoB = Math.min(255, Math.floor(b + (255 - b) * fator));
      coresGradativas.push(rgbParaHex(novoR, novoG, novoB));
    }
    return coresGradativas;
  }

  function hexParaRgb(hex: string): [number, number, number] {
    const hexStr = hex.replace('#', '');
    const r = parseInt(hexStr.substring(0, 2), 16);
    const g = parseInt(hexStr.substring(2, 4), 16);
    const b = parseInt(hexStr.substring(4, 6), 16);
    return [r, g, b];
  }

  function rgbParaHex(r: number, g: number, b: number): string {
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  }

  useEffect(() => {
    const animarSpinner = () => {
      setQuadro((prevQuadro) => (prevQuadro + 1) % cores.length);
    };

    const intervaloId = setInterval(animarSpinner, 150);
    return () => clearInterval(intervaloId);
  }, [cores]);

  useEffect(() => {
    barrasRef?.current.forEach((barra, index) => {
      if (barra) {
        barra.style.fill = cores[(index + quadro) % cores.length];
      }
    });
  }, [quadro, cores]);

  return (
    <svg width={tamanho} height={tamanho} viewBox={`0 0 ${tamanho} ${tamanho}`}>
      {[0, 45, 90, 135, 180, 225, 270, 315].map((angulo, index) => (
        <g
          key={angulo}
          transform={`rotate(${angulo} ${tamanho / 2} ${tamanho / 2})`}
        >
          <rect
            x={tamanho * 0.47}
            y={tamanho * 0.2}
            width={tamanho * 0.08}
            height={tamanho * 0.2}
            rx={tamanho * 0.04}
            fill={cores[0]}
            ref={(el) => {
              barrasRef.current[index] = el;
            }}
          />
        </g>
      ))}
    </svg>
  );
}
